import React, { Component } from "react";
import "./style.css";
class DayUpTip extends Component {
  render() {
    const { msg } = this.props;
    return (
      <div className="day_up_tip">
        <div className="day_up_tip_text">
          <div
            style={{ height: "50px" }}
            dangerouslySetInnerHTML={{ __html: msg }}
          ></div>
          <div
            onClick={() => this.props.handCloseDayUpTip()}
            className="day_up_error_btn"
          >
            确定
          </div>
        </div>
      </div>
    );
  }
}

export default DayUpTip;



// WEBPACK FOOTER //
// ./src/containers/DayUp/components/DayUpTip/index.js